import { LocalStorageAdapter } from '@/infra/cache'

export const makeLocalStorage = (): LocalStorageAdapter => new LocalStorageAdapter()
